import { render, staticRenderFns } from "./FileField.vue?vue&type=template&id=f96a6c40&scoped=true&lang=pug&"
import script from "./FileField.vue?vue&type=script&lang=js&"
export * from "./FileField.vue?vue&type=script&lang=js&"
import style0 from "./FileField.vue?vue&type=style&index=0&id=f96a6c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96a6c40",
  null
  
)

export default component.exports